var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiSmile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0293 0 0 4.0293 0 9C0 13.9707 4.0293 18 9 18C13.9707 18 18 13.9707 18 9C18 4.0293 13.9707 0 9 0ZM9 1.8C12.9762 1.8 16.2 5.0238 16.2 9C16.2 12.9762 12.9762 16.2 9 16.2C5.0238 16.2 1.8 12.9762 1.8 9C1.8 5.0238 5.0238 1.8 9 1.8Z",
    fill: "#8A90A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29999 6.3C5.80292 6.3 5.39999 6.70321 5.39999 7.20001V8.10001C5.39999 8.59681 5.80292 9.00001 6.29999 9.00001C6.79706 9.00001 7.19999 8.59681 7.19999 8.10001V7.20001C7.19999 6.70321 6.79706 6.3 6.29999 6.3ZM11.7 6.3C11.2029 6.3 10.8 6.70321 10.8 7.20001V8.10001C10.8 8.59681 11.2029 9.00001 11.7 9.00001C12.1971 9.00001 12.6 8.59681 12.6 8.10001V7.20001C12.6 6.70321 12.1971 6.3 11.7 6.3ZM6.46874 10.6596C6.23843 10.6596 5.9975 10.737 5.82191 10.9125C5.47055 11.2644 5.47019 11.8269 5.82191 12.1779C6.65963 13.0149 7.79183 13.5 8.99999 13.5C10.204 13.5 11.3411 13.0104 12.1781 12.1779C12.5307 11.8278 12.5285 11.2653 12.1781 10.9125C11.8277 10.5597 11.265 10.5624 10.9125 10.9125C10.4093 11.4129 9.72367 11.7 8.99999 11.7C8.27378 11.7 7.59104 11.4156 7.08749 10.9125C6.91163 10.737 6.69905 10.6596 6.46874 10.6596Z",
    fill: "#8A90A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmile);
export default __webpack_public_path__ + "static/media/emoji-smile.0150de0eae460b1f50d27b74435c684e.svg";
export { ForwardRef as ReactComponent };